import React, { Component } from "react";
import Alert from "react-s-alert";
import {API_BASE_URL} from "../../constants";
import {request} from "../../util/APIUtils";
import {deepCopyObject, showAxiosError} from "../../util/Helpers";
class CalendarNote extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: props.currentEvent.title,
            time: props.currentEvent.time,
            date: props.selectedDate,
            note: props.currentEvent.note,
            id: props.currentEvent.id
        };
        this.listCalender=this.listCalender.bind(this);
    }
    handleTitleChange = (e) => {
        this.setState({ title: e.target.value });
    };
    handleTimeChange = (e) => {
        this.setState({ time: e.target.value });
    };
    handleNoteChange = (e) => {
        this.setState({ note: e.target.value });
    };
    validateInfo(){
        const { title, startTime, note, id , time } = this.state;
        let errorMessage='';
        if(title===""){
            errorMessage += 'Etkinlik Adı Boş Olamaz!</br>'  ;
        }
        if(time===""){
            errorMessage +='Etkinlik Saati Boş Olamaz!</br>'
        }
        if(note===""){
            errorMessage +='Not Alanı Boş Olamaz!</br>'
        }
        return errorMessage;
    }
    listCalender() {
        let self = this;
        let params = {
            url: API_BASE_URL+'/calender/listCalender' ,
            method: "get",
        };
        self.setState({loading: true});
        request(params)
            .then(function (response) {
                let calenderList = response.data;
                self.setState({
                    calenderList,
                    loading: false,
                    searching: false
                });
            }).catch(function (error) {
            self.setState({loading: false, searching: false});
            showAxiosError(error);
        });
    }
    saveNote = () => {
        const { title, time, note, id } = this.state;
        let self = this;
        let params;
        let data;
        let message;
        let validity = this.validateInfo();
        if (validity ===''){
            let calenderNote = deepCopyObject(this.state);
            data=calenderNote;
                if (calenderNote.id === null) {
                    message = 'Etkinlik Başarıyla Oluşturuldu.'
                    params = {
                        url: API_BASE_URL + "/calender",
                        data: data,
                        method: 'post'
                    };
                    setTimeout(() => {
                        document.location.reload();
                    }, 2000);
                } else {
                    message = 'Etkinlik Başarıyla Güncellendi.'
                    params = {
                        url: API_BASE_URL + "/calender",
                        data: data,
                        method: 'patch'
                    };
                    setTimeout(() => {
                        document.location.reload();
                    }, 2000);
                }
            request(params).then((response) => {
                const newId = response.data.id;
                const newEvent = {
                    title: title,
                    time: time,
                    date: this.state.date,
                    note: note,
                    id: newId
                };

                this.props.onSave(newEvent);
                this.props.onCancel();

                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                self.setState({isLoading:false});
            }).catch(function (error) {
                self.setState({isLoading:false});
                showAxiosError(error);
            });
        }
        else {
            Alert.error(
                validity, {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 20000
                });
        }

    }
    render() {
        const event = new Date(this.state.date);
        const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        return (
            <div className="oda-form-container">
                <div className="card-body mt-1">
                    {/*<div>*/}
                    {/*    <label>id   {this.state.id}</label>*/}
                    {/*</div>*/}
                    <div>
                        {/*<label>{this.state.date}</label>*/}
                        <label>SEÇİLEN TARİH:   {event.toLocaleDateString(undefined, options)}</label>
                    </div>


                    <div className="FormRenk col-sm-12">
                        <div className="col-sm-12 row">
                            <div className="col-sm-4">
                                <label>Etkinlik Adı:</label>
                            </div>
                                <div className="col-sm-8">
                                <input
                                    type="text"
                                    value={this.state.title}
                                    onChange={this.handleTitleChange}
                                    style={{width:"100%"}}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 row">
                            <div className="col-sm-4">
                                <label>Not:</label>
                            </div>
                                <div className="col-sm-8">
                                <textarea rows="4" cols="50"
                                    value={this.state.note}
                                    onChange={this.handleNoteChange}
                                />
                            </div>
                        </div>
                        <div className="col-sm-12 row">
                            <div className="col-sm-4">
                                <label>Etkinlik Saati:</label>
                            </div>
                            <div className="col-sm-8">
                                <input
                                    type="time"
                                    value={this.state.time}
                                    onChange={this.handleTimeChange}
                                    style={{width:"100%"}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <div className="col-sm-12 row">
                        <div className="col-sm-12" style={{marginLeft:'40px'}}>
                            <button
                                type="button"
                                style={{
                                    background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                    float: 'right',
                                    padding: '10px 54px 10px 23px',
                                }}
                                className="TekBtn kaydet"
                                onClick={this.saveNote}>
                                {this.props.mode === 'create' ? 'Onayla' : 'Kaydet'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CalendarNote;



// WEBPACK FOOTER //
// ./src/page/agenda/CalendarNote.js